import config from './config';

import App from './App.js';

const Trail = App;

export default Trail;



// WEBPACK FOOTER //
// ./src/scripts/Trail/index.js